//@flow
import React, {useState} from 'react';
import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  makeStyles,
  Typography,
} from '@material-ui/core';
import {useFormContext} from 'react-hook-form';

import ImageInput from './ImageInput';
import {
  BANNER_MEDIA_ASPECT_RATIO,
  BANNER_MEDIA_SIZES,
} from '../../../../../constants';
import {MAIN_BANNER_FIELDS} from '../constants';
import Toast from '../../../../../../../elements/Toast';

import type {BannerMediaType} from '../../../../../../../entities';
import VideoBannerForm from '../VideoBannerForm';
import {colors} from '../../../../../../../assets/styles/colors';
type Props = {
  classes?: {
    root?: string,
    imageRoot?: string,
  },
};

const useStyles = makeStyles(theme => ({
  imageRoot: {
    display: 'grid',
    gridTemplateRows: '1fr 1fr',
    width: '100%',
    gap: '1rem',

    [theme.breakpoints.up('sm')]: {
      gridTemplateColumns: '1fr 1fr',
      gridTemplateRows: '1fr',
    },
  },
  radioGroup: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',
    marginBottom: '1rem',
  },
  captionText: {
    fontSize: '0.875rem',
    color: colors.grey600,
    marginBottom: '.25rem',
    fontWeight: 500,
  },
}));

export default function BannerMedia(props: Props) {
  const classes = useStyles();

  const {setValue, errors, clearErrors, watch} = useFormContext();

  const [mediaSelected, setMediaSelected] = useState<BannerMediaType>('IMAGE');

  const imageDesktopError = !!errors[MAIN_BANNER_FIELDS.IMAGE_DESKTOP];
  const imageMobileError = !!errors[MAIN_BANNER_FIELDS.IMAGE_MOBILE];

  const imageDesktop = watch(MAIN_BANNER_FIELDS.IMAGE_DESKTOP);
  const imageMobile = watch(MAIN_BANNER_FIELDS.IMAGE_MOBILE);
  const bannerSize = watch(MAIN_BANNER_FIELDS.BANNER_SIZE);

  const propClasses = props.classes || {};

  const imageRootClasses = `${classes.imageRoot} ${
    propClasses.imageRoot ? propClasses.imageRoot : ''
  }`;

  const rootClasses = `${classes.root} ${
    propClasses.root ? propClasses.root : ''
  }`;

  const aspectRatio = BANNER_MEDIA_ASPECT_RATIO[bannerSize];
  const size = BANNER_MEDIA_SIZES[bannerSize];

  return (
    <section className={rootClasses}>
      <FormControl component="fieldset">
        <RadioGroup
          aria-label="Tipo de banner"
          value={mediaSelected}
          className={classes.radioGroup}
          onChange={event => setMediaSelected(event.target.value)}
        >
          <FormControlLabel
            value="IMAGE"
            control={<Radio color="primary" />}
            label="Imagen"
          />
          <FormControlLabel
            value="VIDEO"
            control={<Radio color="primary" />}
            label="Video"
          />
        </RadioGroup>
      </FormControl>

      {mediaSelected === 'IMAGE' && (
        <>
          <Typography className={classes.captionText}>
            Máx. 1 MB por imagen. Archivos más grandes se comprimirán.
          </Typography>
          <div className={imageRootClasses}>
            <ImageInput
              value={imageDesktop}
              onChange={file => {
                setValue(MAIN_BANNER_FIELDS.IMAGE_DESKTOP, file);
                clearErrors(MAIN_BANNER_FIELDS.IMAGE_DESKTOP);
              }}
              aspectRatio={aspectRatio.desktop}
              error={imageDesktopError}
              label="Version Desktop"
              sizeRecommendation={`${size.desktop.width} x ${size.desktop.height}`}
              /*    dynamicAspectRatio={{
              rectangle: {
                aspect: aspectRatio.desktop,
              },
              square: {
                aspect: 1,
              },
            }} */
            />
            <ImageInput
              value={imageMobile}
              onChange={file => {
                setValue(MAIN_BANNER_FIELDS.IMAGE_MOBILE, file);
                clearErrors(MAIN_BANNER_FIELDS.IMAGE_MOBILE);
              }}
              error={imageMobileError}
              aspectRatio={aspectRatio.mobile}
              label="Version Mobile"
              sizeRecommendation={`${size.mobile.width} x ${size.mobile.height}`}
            />
            <Toast
              open={imageDesktopError || imageMobileError}
              onClose={() => {}}
              severity="error"
              closeDelay={5000}
            >
              Asegurese de subir una imagen para la versión desktop y mobile
            </Toast>
          </div>
        </>
      )}
      {mediaSelected === 'VIDEO' && <VideoBannerForm />}
    </section>
  );
}
